import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { UseCase } from "../../base/use-case.js";
import { GetVehicleGroupRequest } from "../../domain/requests/vehicle-group/vehicle-group.js";
import { VehicleGroup } from "../../domain";
import { VehicleGroupRepository } from "../../repositories/vehicle-group.repository";
import { VehicleGroupDto } from "../../domain/requests/vehicle-group/create-edit-vehicle-group-request.js";

@Injectable()
export class GetvehicleGroupUsecase implements UseCase<string, VehicleGroupDto[]> {

  constructor(private vehicleGroupRepository: VehicleGroupRepository) {
  }

  execute(planId:string): Observable<VehicleGroupDto[]> {
    return this.vehicleGroupRepository.getVehicleGroups(planId);
  }

}
